// Vehicle English translations
export const vehicleEn = {
  'add.vehicle': 'Add Vehicle',
  'add.vehicle.capacity': 'Add Vehicle Capacity',
  'all.vehicles': 'All Vehicles',
  'all.vehicles.efficiency': 'All Vehicles Efficiency',
  'capacity.tons': 'Capacity (tons)',
  'edit.vehicle': 'Edit Vehicle',
  'error.creating.vehicle': 'Error creating vehicle',
  'error.deleting.vehicle': 'Error deleting vehicle',
  'error.updating.vehicle': 'Error updating vehicle',
  'failed.to.load.vehicles': 'Failed to load vehicles',
  'fees.auto.calculated.based.on.vehicle.capacity.and.destination': 'Fees are auto-calculated based on vehicle capacity and destination',
  'license.plate': 'License Plate',
  'license.plate.alphanumeric.only': 'License plate must contain only letters and numbers',
  'manage.capacity.tons': 'Manage Capacity Tons',
  'no.synced.vehicles': 'No vehicles synced with VCOMSAT',
  'no.synced.vehicles.hint': 'No vehicles synced with VCOMSAT. Please sync vehicles first from the Vehicles page.',
  'please.select.vehicle': 'Please select a vehicle first',
  'preferred.vehicle': 'Preferred Vehicle',
  'select.capacity': 'Select capacity',
  'select.vehicle': 'Select vehicle',
  'total.vehicles': 'Total Vehicles',
  'tracked.vehicles': 'Tracked Vehicles',
  'truck': 'Truck',
  'truck.detailed.report': 'Truck Payment Report',
  'truck.number': 'Truck Number',
  'vcomsat.sync.vehicles': 'Sync with VCOMSAT',
  'vcomsat.total.vehicles': 'Total VCOMSAT Vehicles',
  'vehicle': 'Vehicle',
  'vehicle.capacity': 'Vehicle Capacity',
  'vehicle.capacity.optional': 'Vehicle Capacity (Optional)',
  'vehicle.capacity.tons': 'Vehicle Capacity Tons',
  'vehicle.capacity.tons.management': 'Vehicle Capacity Tons Management',
  'vehicle.created.successfully': 'Vehicle created successfully',
  'vehicle.deleted.successfully': 'Vehicle deleted successfully',
  'vehicle.details': 'Vehicle Details',
  'vehicle.list': 'Vehicle List',
  'vehicle.management': 'Vehicle Management',
  'vehicle.not.synced.with.vcomsat': 'No Synced Vehicles',
  'vehicle.tracking': 'Vehicle Tracking',
  'vehicle.updated.successfully': 'Vehicle updated successfully',
  'vehicles': 'Vehicles',
  'traffic.signs.not.available': 'Traffic signs not available (check data.wmap.update)',
  'traffic.signs.hide': 'Hide traffic signs',
  'traffic.signs.show': 'Show traffic signs',
  'traffic.signs.hide.full': 'Hide traffic signs',
  'traffic.signs.show.full': 'Show traffic signs',
  'traffic.signs': 'Traffic Signs',
  'traffic.signs.full': 'Traffic Signs',
  'traffic.signs.legend.speed.limit': 'Speed',
  'traffic.signs.legend.camera': 'Camera',
  'traffic.signs.legend.other': 'Other',
};
